import { isNumber, isString } from 'lodash'

interface overrideSettings {
  idKey?: string
  childrenKey?: string
}

export interface nodeType {
  [idKey: string]: string | any
  isLeaf?: boolean
  hasChild?: boolean
  expand?: boolean
  isLastItem?: boolean
  idPath: nodeType[]
  parentId?: string
  icon?: string
}

export interface itemType {
  [idKey: string]: string | any
  title: string
  groupName?: string
  children: itemType[]
  visible?: boolean
}

type cbFn = (x?: itemType) => nodeType

export function treeToFlatList(
  list: itemType[] = [],
  hookCb: cbFn = () => ({ idPath: [] }),
  overrideKey: overrideSettings = {},
): nodeType[] {
  const { idKey = 'id', childrenKey = 'children' } = overrideKey
  const flatList: nodeType[] = []
  let idCollection: any = new Map()

  function checkEdge(treeNode: itemType) {
    const nodeId = treeNode[idKey]
    if (!isNumber(nodeId) && !isString(nodeId)) {
      throw new Error(`The type [${idKey} property] Of Tree Node Must Be String Or Number: ${nodeId}`)
    }
    if (idCollection.has(nodeId)) {
      throw new Error(`The ${idKey} Of Tree Node Is Duplicate: ${nodeId}`)
    } else {
      idCollection.set(nodeId, nodeId)
    }
  }

  function recursiveTreeNode(
    treeList: itemType[],
    hookTreeNode: cbFn,
    parentId: string | undefined,
    parentNode: nodeType | undefined,
    level: number = 0,
  ) {
    treeList.forEach((treeNode, index: number) => {
      let flatNode: nodeType = {
        idPath: [],
      }
      checkEdge(treeNode)
      Object.keys(treeNode).forEach(key => {
        if (key !== childrenKey) {
          flatNode[key] = treeNode[key]
        }
      })

      flatNode.isLeaf = false
      flatNode.hasChild = false
      flatNode.parentId = parentId
      flatNode.isLastItem = index === treeList.length - 1
      flatNode.idPath = parentNode
        ? [...parentNode.idPath, treeNode[idKey]]
        : [treeNode[idKey]]

      const nodeChildren = treeNode[childrenKey]
      const childrenEmpty = Array.isArray(nodeChildren) && nodeChildren.length < 1
      if (!nodeChildren || childrenEmpty) {
        flatNode.isLeaf = true
      }

      const hookNode = hookTreeNode({
        level,
        ...treeNode,
      }) || {}
      flatNode = { ...hookNode, ...flatNode }

      flatList.push(flatNode)
      if (Array.isArray(nodeChildren)) {
        flatNode.hasChild = true
        recursiveTreeNode(
          nodeChildren,
          hookTreeNode,
          treeNode[idKey],
          flatNode,
          level + 1,
        )
      }
    })
  }
  recursiveTreeNode(list, hookCb, undefined, undefined, 0)
  idCollection = null
  return flatList
}
